import React from 'react';

import { useGroupState, useGroupActions } from './GroupContext';
import { removeMember, subscribeMember, unsubscribeMember } from './restApi';
import Button from '../../Shared/UI/Button/components/Button';

import styles from './PermissionsSection.module.scss';

const SUBSCRIPTION_STATUS_LABELS = {
  premium_group_paid: 'Premium (group-paid)',
  premium_fee_waived: 'Premium (fee waived)',
  premium_other: 'Premium',
  free: 'Free',
};

const GroupMembersSection = () => {
  const state = useGroupState();
  const { onResponse, onError } = useGroupActions();
  const members = state?.members || [];

  const groupId = state?.group?.id;
  const hasGroupPaymentMethod = !!state?.groupPaymentMethod;
  const taxExempt = state?.taxExempt;
  const authenticityToken = document.querySelector("meta[name='csrf-token']")?.getAttribute("content");

  const handleRemoveMember = (userId) => {
    removeMember({
      id: groupId,
      onResponse,
      onError,
      body: { userId, authenticityToken },
    });
  };

  const handleSubscribeMember = (userId) => {
    subscribeMember({
      id: groupId,
      onResponse,
      onError,
      body: { userId, authenticityToken },
    });
  };

  const handleUnsubscribeMember = (userId) => {
    unsubscribeMember({
      id: groupId,
      onResponse,
      onError,
      body: { userId, authenticityToken },
    });
  };

  const renderSubscriptionAction = (user) => {
    const status = user.subscriptionStatus;

    if (status === 'premium_group_paid') {
      if (user.subscriptionCanceledAt) {
        return (
          <span className={styles.ownerBadge}>Canceling</span>
        );
      }
      return (
        <Button variant="ghost" onClick={() => handleUnsubscribeMember(user.id)}>
          Cancel Subscription
        </Button>
      );
    }

    if (status === 'free' && hasGroupPaymentMethod) {
      return (
        <Button variant="secondary" onClick={() => handleSubscribeMember(user.id)}>
          Subscribe
        </Button>
      );
    }

    return null;
  };

  return (
    <div className={styles.adminsSection}>
      <h3 className={styles.adminsSectionTitle}>Group Members</h3>
      <p className={styles.adminsSectionDescription}>
        Members have base access to the group. Admins can remove members and manage their subscriptions.
      </p>

      <div className={styles.adminsSubsection}>
        <span className={styles.subsectionLabel}>Current members:</span>
        {members.length > 0 ? (
          <ul className={styles.userList}>
            {members.map((user) => (
              <li key={user.id} className={styles.userRow}>
                <img
                  src={user.profilePicturePath}
                  alt={user.name}
                  className={styles.avatar}
                />
                <span className={styles.userName}>{user.name}</span>
                <span className={styles.ownerBadge}>
                  {SUBSCRIPTION_STATUS_LABELS[user.subscriptionStatus] || 'Free'}
                </span>
                {renderSubscriptionAction(user)}
                <Button variant="secondary" onClick={() => handleRemoveMember(user.id)}>
                  Remove
                </Button>
              </li>
            ))}
          </ul>
        ) : (
          <p className={styles.coveredNote}>No members.</p>
        )}
        {hasGroupPaymentMethod && !taxExempt && (
          <p style={{ color: '#856404', fontSize: '13px', marginTop: '8px' }}>
            Tax-exempt? Contact{' '}
            <a href="mailto:contact@isibute.com">contact@isibute.com</a>{' '}
            before subscribing to avoid being charged sales tax.
          </p>
        )}
      </div>
    </div>
  );
};

export default GroupMembersSection;
